import React, { useEffect } from "react";
import { range } from "range";
import { GroupMember, Product } from "~/common/Store/models/ProductListing";
import { cls } from "cls";

export const incrementCount = 16;

interface QuantityDropdown {
  handleQuantityChange: (value: string) => void;
  product: Product;
  grouping: boolean;
  lastQuantityInterval: number;
  quantity: string;
  forceCustomQuantity: boolean;
  handleAddToCart: (event: React.SyntheticEvent) => void;
  selectedGroupMember: false | "" | GroupMember | undefined;
  mustPurchaseMoreThanOne: boolean;
  startBuy: number;
  mustBuy: number;
  isCompareWithProductBox?: boolean;
  productListingView?: string;
  undoBtnContainerStyle?: boolean;
}

const QuantityDropdown = ({
  handleQuantityChange,
  lastQuantityInterval,
  quantity,
  forceCustomQuantity,
  handleAddToCart,
  selectedGroupMember,
  mustPurchaseMoreThanOne,
  startBuy,
  mustBuy,
  isCompareWithProductBox,
  productListingView,
  undoBtnContainerStyle,
}: QuantityDropdown) => {
  const handleQuantityChanged = ({
    target: { value },
  }: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) =>
    handleQuantityChange(value);

  useEffect(() => {
    handleQuantityChange(startBuy.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupMember]);

  let increments = mustPurchaseMoreThanOne
    ? range(0, incrementCount).map((index) => startBuy + index * mustBuy)
    : [];

  if (selectedGroupMember && selectedGroupMember.mustPurchaseMoreThanOne) {
    increments = range(0, incrementCount).map(
      (index) =>
        selectedGroupMember.startBuy + index * selectedGroupMember.mustBuy,
    );
  }

  return (
    <div
      className={cls(
        "cartAndQuantity",
        undoBtnContainerStyle && productListingView === "grid" && "-ml-[30px]",
        isCompareWithProductBox && "text-left",
      )}
    >
      <span className="sr-only" id="select-other-callout">
        selecting other will provide a text input
      </span>
      <select
        aria-label="quantity"
        aria-describedby="select-other-callout"
        defaultValue="0"
        className="qty_dropdown configure qty-preset-select"
        onChange={handleQuantityChanged}
        name="qty"
        data-testid="dropDownCartQty"
        value={quantity}
      >
        {range(1, incrementCount).map((i) => (
          <option key={i} value={increments[i - 1]}>
            {increments[i - 1]}
          </option>
        ))}
        <option value={lastQuantityInterval}>Other</option>
      </select>
      <input
        className="add_qty quantity"
        aria-label="quantity"
        min="1"
        name="qty"
        type="number"
        onChange={handleQuantityChanged}
        value={quantity}
        hidden={!forceCustomQuantity}
        data-testid="itemAddCartQty"
      />
      <input
        type="submit"
        className="btn btn-cart btn-small"
        name="addToCartButton"
        value="Add to Cart"
        onClick={handleAddToCart}
        data-testid="itemAddCart"
        data-action="addToCart"
      />
    </div>
  );
};

export default QuantityDropdown;
